import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { interval } from "rxjs";

@Component(
    {
        selector: 'app-count-down',
        template: `
           <div class="container pt-5">
                <div class="text-center">
                    <img class="img" src="assets/img/ems-logo.png">
                </div>
                <h5>Dear Customer,</h5>
            <div class="timer-box" *ngIf="!isLive">
                <div>
                    The reset password link is not available now, kindly reset your password starting from 15 Feb, 8.30am.
                </div>
                <div class="text-center mt-3 text-muted">Remaining…</div>
                <div class="text-center my-3">
                    <!-- <input type="datetime" [ngModel]="dataLine" (change)="changeDate($event)"> -->
                    <div class="timer-container text-center bg-dark p-5">
                    <table class="table mt-2">
                        <thead>
                        <tr>
                            <th>DAYS</th>
                            <th>HOURS</th>
                            <th>MINUTES</th>
                            <th>SECONDS</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="flip-2-hor-top-1">{{myTimer.days}}</td>
                            <td class="flip-2-hor-top-1">{{myTimer.hours}}</td>
                            <td class="flip-2-hor-top-1">{{myTimer.minutes}}</td>
                            <td class="flip-2-hor-top-1">{{myTimer.seconds}}</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
            <div class="text-center my-5" *ngIf="isLive">
                <p>The reset password link is available now </p>
            </div>
                <div> <br>
                    <p>For more enquiries, please contact fmx.sales@freightmark.com.my for clarification. </p>
                    <p class="ml-4">Yours Sincerely,</p>
                    <b>FMX (M) Sdn Bhd</b> <br>
                    General Line: +603-5740 8488 / +6019-6664538 <br>
                    Fax: +603 5740 8836 <br>
                    Customer Experience Hotline: 1 700 818 FMX (1 700 818 369) <br>

            </div>
        </div>
        `,
        styles: [`
            .timer-container{
                background-color:"black";
                width: 500px;
                margin:auto;
                border-radius:5px;
            }
            .img{
                width: 200px;
            }

            table, td {
                font-size: 58px !important;
                border: solid 6px #00427b;
            }

            .flip-2-hor-top-1{
                -webkit-animation:flip-2-hor-top-1 .5s cubic-bezier(.455,.03,.515,.955) both;
                animation:flip-2-hor-top-1 .5s cubic-bezier(.455,.03,.515,.955) both
            }
        `]
    }
)

export class CountDownComponent implements OnInit {
    myTimer = {total:0.00,days:0.00,hours:0.00,minutes:0.00,seconds:1.00}
    dataLine = new Date('Mon Feb 15 2021 08:00:00 GMT+0800');
    isLive:boolean=false;
    constructor(private router:Router){}
    ngOnInit() {

        if (this.dataLine < new Date()) {
            this.isLive = true;
            return this.router.navigate(['./login']);
        }

        const refreshIntervalId = interval(1000).pipe().subscribe((x) => {
            this.getTimeRemaining(this.dataLine, refreshIntervalId);
        });
    }
    getTimeRemaining(endtime, refreshIntervalId) {
        if (this.myTimer.seconds < 1 && this.myTimer.minutes < 1 && this.myTimer.days < 1) {
            this.isLive = true;
            if (refreshIntervalId) {
                refreshIntervalId.unsubscribe();
            }
            return this.router.navigate(['./login']);
        }
        const total = Date.parse(endtime) - Date.parse(new Date()+"");
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));

        this.myTimer = {
            total,
            days,
            hours,
            minutes,
            seconds
        };
        return this.myTimer;
    }

    changeDate(myDate){
        console.log(myDate.target.value);
        this.dataLine = new Date(myDate.target.value);
    }
}
